if (!customElements.get('article-cart-add')) {
  customElements.define(
    'article-cart-add',
    class ArticleCartAdd extends HTMLElement {
      constructor() {
        super();
        this.form = this.querySelector('form');
        this.button = this.querySelector('[type="submit"]');
        this.spinner = this.querySelector('.loading__spinner');
        if (this.form) this.form.addEventListener('submit', this.onSubmit.bind(this));
      }

      get cartTarget() {
        return document.querySelector('cart-drawer') || document.querySelector('cart-notification');
      }

      onSubmit(event) {
        event.preventDefault();
        if (this.button.getAttribute('aria-disabled') === 'true') return;

        this.setLoading(true);

        const config = (typeof fetchConfig === 'function') ? fetchConfig('javascript') : { method: 'POST', headers: { Accept: 'application/javascript', 'X-Requested-With': 'XMLHttpRequest' } };
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);
        const cart = this.cartTarget;
        if (cart && typeof cart.getSectionsToRender === 'function') {
          formData.append('sections', cart.getSectionsToRender().map((section) => section.id));
          formData.append('sections_url', window.location.pathname);
          if (typeof cart.setActiveElement === 'function') cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

        fetch(`${window.routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
                publish(PUB_SUB_EVENTS.cartError, {
                  source: 'article-cart-add',
                  productVariantId: formData.get('id'),
                  errors: response.errors || response.description,
                  message: response.message,
                });
              }
              this.flashError();
              return;
            }

            if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'article-cart-add',
                productVariantId: formData.get('id'),
                cartData: response,
              });
            }

            if (cart && typeof cart.renderContents === 'function') {
              if (cart.classList && cart.classList.contains('is-empty')) cart.classList.remove('is-empty');
              cart.renderContents(response);
            } else {
              this.refetchCartBubble();
              this.flashSuccess();
            }
          })
          .catch((err) => {
            console.error(err);
            this.flashError();
          })
          .finally(() => {
            this.setLoading(false);
          });
      }

      setLoading(state) {
        if (!this.button) return;
        this.button.classList.toggle('loading', state);
        this.button.setAttribute('aria-disabled', state ? 'true' : 'false');
        if (this.spinner) this.spinner.classList.toggle('hidden', !state);
      }

      refetchCartBubble() {
        const bubble = document.querySelector('.cart-count-bubble') || document.querySelector('#cart-icon-bubble');
        if (!bubble) return;
        fetch(`${window.routes.cart_url || '/cart'}?section_id=cart-icon-bubble`)
          .then((r) => r.text())
          .then((html) => {
            const parsed = new DOMParser().parseFromString(html, 'text/html');
            const next = parsed.querySelector('#shopify-section-cart-icon-bubble');
            const current = document.querySelector('#shopify-section-cart-icon-bubble');
            if (next && current) current.innerHTML = next.innerHTML;
          })
          .catch(() => {});
      }

      flashSuccess() {
        if (!this.button) return;
        this.button.classList.add('is-flash-success');
        setTimeout(() => this.button.classList.remove('is-flash-success'), 1100);
      }

      flashError() {
        if (!this.button) return;
        this.button.classList.add('is-flash-error');
        setTimeout(() => this.button.classList.remove('is-flash-error'), 1100);
      }
    }
  );
}
